import { FormikProps } from 'formik';
// import { Button, Col, Row } from 'reactstrap';
import {
  Button,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { CustomerFormType, PickupAddress } from 'types/customer/customerTypes';
import CustomerAddressSection from 'pages/Customers/CustomerManagementModals/FormComponents/CustomerAddressSection';
import CustomerContactSection from 'pages/Customers/CustomerManagementModals/FormComponents/CustomerContactSection';
import CustomerCreditSection from 'pages/Customers/CustomerManagementModals/FormComponents/CustomerCreditSection';
import CustomerFinancialSection from 'pages/Customers/CustomerManagementModals/FormComponents/CustomerFinancialSection';
import CustomerInfoSection from 'pages/Customers/CustomerManagementModals/FormComponents/CustomerInfoSection';
import useWindowSize from 'Components/Hooks/WindowSizeHook';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useLocation } from 'react-router-dom';
import { useMemo, useState } from 'react';
import TopLabelCustomerInfoSection from './FormComponents/TopLabelStyle/TopLabelCustomerInfoSection';
import TopLabelCustomerAddressSection from './FormComponents/TopLabelStyle/TopLabelCustomerAddressSection';
import TopLabelCustomerContactSection from './FormComponents/TopLabelStyle/TopLabelCustomerContactSection';
import TopLabelCustomerFinancialSection from './FormComponents/TopLabelStyle/TopLabelCustomerFinancialSection';
import TopLabelCustomerCreditSection from './FormComponents/TopLabelStyle/TopLabelCustomerCreditSection';
import PickUpTab from 'pages/Customers/CustomerManagementModals/Tabs/PickUpTab';
import { useDispatch } from 'react-redux';
import {
  setCountCustomerSubmit,
  setCustomerModalOpen,
} from 'slices/customer/reducer';
// import 'styles/common/tabs.css';

const ManageCustomerFormWithTabsV2 = ({
  formik,
  closeAddAndEditCustomers,
  availableBranchAccess,
  handleDeletePickupAddr,
  generalTabRef,
  pickupTabRef,
}: {
  formik: FormikProps<CustomerFormType>;
  closeAddAndEditCustomers: boolean;
  availableBranchAccess: boolean;
  handleDeletePickupAddr: (option: PickupAddress) => void;
  generalTabRef: React.RefObject<any>;
  pickupTabRef: React.RefObject<any>;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { width } = useWindowSize();
  const isMobile = width <= 1024;
  const { storeType } = useSelector((s: RootState) => s.Info);

  const location = useLocation();
  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const alignmentStyle = query.get('style');
  const UIAlignment = alignmentStyle === 'top' ? 'top' : 'left';

  const [activeTab, setActiveTab] = useState<'general' | 'pickup'>('general');

  const toggleTab = (tab: 'general' | 'pickup') => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <Nav
        tabs
        className="nav-tabs-custom mb-4"
        // style={{ borderBottom: '1px solid #4bb189' }}
      >
        <NavItem>
          <NavLink
            ref={generalTabRef}
            data-tab="general"
            className={classnames({ active: activeTab === 'general' })}
            onClick={() => toggleTab('general')}
            style={{ cursor: 'pointer', color: '#4bb189' }}
          >
            {t('General')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            ref={pickupTabRef}
            data-tab="pickup"
            className={classnames({ active: activeTab === 'pickup' })}
            onClick={() => toggleTab('pickup')}
            style={{ cursor: 'pointer', color: '#4bb189' }}
          >
            {t('Pickup Address')}
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="general">
          {UIAlignment !== 'top' ? (
            <>
              <Row>
                <Col lg={6}>
                  {/* <Col md={6} className="px-4"> */}

                  <CustomerInfoSection
                    formik={formik}
                    availableBranchAccess={availableBranchAccess}
                  />
                </Col>

                <Col
                  lg={6}
                  // style={{
                  //   paddingLeft: isMobile ? '' : '2rem',
                  //   paddingRight: isMobile ? '' : '2rem',
                  // }}
                >
                  {/* <Col md={6} className="px-4"> */}
                  <CustomerContactSection formik={formik} />
                  <CustomerFinancialSection formik={formik} />

                  {storeType === 0 && <CustomerCreditSection formik={formik} />}
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <CustomerAddressSection formik={formik} />
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              <Col
                lg={6}
                style={{
                  paddingLeft: isMobile ? '' : '2rem',
                  paddingRight: isMobile ? '' : '2rem',
                }}
              >
                {/* <Col lg={6} style={{ paddingLeft: isMobile ? '' : '1.5rem' }}> */}
                {/* <Col md={6} className="px-4"> */}

                <TopLabelCustomerInfoSection
                  formik={formik}
                  availableBranchAccess={availableBranchAccess}
                />

                <TopLabelCustomerAddressSection formik={formik} />
              </Col>

              {/* <Col lg={6} style={{ paddingLeft: isMobile ? '' : '2.5rem' }}> */}
              <Col
                lg={6}
                style={{
                  paddingLeft: isMobile ? '' : '2rem',
                  paddingRight: isMobile ? '' : '1rem',
                }}
              >
                {/* <Col md={6} className="px-4"> */}
                <TopLabelCustomerContactSection formik={formik} />
                <TopLabelCustomerFinancialSection formik={formik} />

                {storeType === 0 && (
                  <TopLabelCustomerCreditSection formik={formik} />
                )}
              </Col>
            </Row>
          )}
        </TabPane>
        <PickUpTab
          formik={formik}
          handleDeletePickupAddr={handleDeletePickupAddr}
        />
      </TabContent>

      <Row className="mt-4">
        <Col xs={12} sm={12} className="text-center">
          <div className="mb-3">
            <Row>
              <Col xs={1} md={2} lg={4}></Col>
              <Col xs={5} md={4} lg={2}>
                <Button
                  block
                  outline
                  color="dark"
                  className="btn btn-ghost-light material-shadow-none"
                  type="button"
                  onClick={() => {
                    dispatch(setCustomerModalOpen(false));
                  }}
                >
                  {t('Btn_Cancel')}
                </Button>
              </Col>

              <Col xs={5} md={4} lg={2}>
                <Button
                  block
                  type="submit"
                  color="success"
                  disabled={formik.isSubmitting}
                  className={`${closeAddAndEditCustomers ? 'd-none' : ''}`}
                  onClick={async () => {
                    // wait for formik validation to complete
                    await formik.validateForm();

                    //then countSubmit ++
                    dispatch(setCountCustomerSubmit());
                  }}
                >
                  {t('Save')}
                </Button>
              </Col>
              <Col xs={1} md={2} lg={2}></Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ManageCustomerFormWithTabsV2;
